import React from 'react';
import styles from './UpperSidedrawerOption.module.css';

const UpperSidedrawerOption = props => (
    <div className={ styles.UpperSidedrawerOption }>
        <p className={ styles.Label }> { props.info } </p>
    </div>
);

export default UpperSidedrawerOption;